module.exports = __webpack_public_path__ + "img/popup_icon_like_normal.2f77d332.svg";